var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resizable-aside",style:({ width: _vm.currentWidth + 'px' })},[_c('div',{staticClass:"aside-content"},[_vm._t("default")],2),_c('div',{staticClass:"resizer",on:{"mousedown":_vm.startDrag}})])
}
var staticRenderFns = []

export { render, staticRenderFns }